import React, { createContext, useContext, useEffect, useState } from 'react';

const LanguageContext = createContext(null);

const dictionary = {
  el: {
    // Home nav
    'nav.architects': 'ΑΡΧΙΤΕΚΤΟΝΕΣ',
    'nav.private': 'ΙΔΙΩΤΕΣ',
    'nav.aluminum': 'ΣΥΣΤΗΜΑΤΑ ΑΛΟΥΜΙΝΙΟΥ',
    'nav.company': 'ΕΤΑΙΡΕΙΑ',
    'nav.contact': 'ΕΠΙΚΟΙΝΩΝΙΑ',
    'home.title': 'ΧΑΤΖΗΑΝΔΡΕΟΥ',
    'home.subtitle': 'ΜΕΤΑΛΛΙΚΕΣ ΚΑΤΑΣΚΕΥΕΣ - ΣΥΣΤΗΜΑΤΑ ΑΛΟΥΜΙΝΙΟΥ',
    'home.skip': 'Μετάβαση στο κύριο περιεχόμενο',

    // Common
    'common.close': 'Κλείσιμο',
    'common.back': 'Πίσω',
    'common.viewMore': 'Δείτε Περισσότερα',
    'common.home': 'Αρχική',
    'common.download': 'Λήψη',
    'common.loading': 'Φόρτωση...',
    'common.partnerLogin': 'Είσοδος Συνεργάτη',

    // Architects modal
    'arch.title': 'Αρχιτέκτονες',
    'arch.h3': 'Λύσεις για Επαγγελματίες Αρχιτέκτονες',
    'arch.p1': 'Η Χατζηανδρέου συνεργάζεται στενά με αρχιτέκτονες και μελετητές για την υλοποίηση των πιο απαιτητικών αρχιτεκτονικών σχεδίων. Προσφέρουμε εξειδικευμένες λύσεις αλουμινίου που συνδυάζουν αισθητική, λειτουργικότητα και ενεργειακή απόδοση.',
    'arch.h4': 'Υπηρεσίες που προσφέρουμε:',
    'arch.list': [
      'Τεχνική υποστήριξη και συμβουλευτική σε όλα τα στάδια του έργου',
      'Προσαρμοσμένες λύσεις για ειδικές αρχιτεκτονικές απαιτήσεις',
      'Σχεδιασμός custom συστημάτων αλουμινίου',
      'Τρισδιάστατες απεικονίσεις και μελέτες',
      'Πιστοποιημένα προϊόντα με υψηλές προδιαγραφές',
      'Τήρηση χρονοδιαγραμμάτων και προϋπολογισμών',
    ],
    'arch.p2': 'Με εμπειρία δεκαετιών στον κλάδο, κατανοούμε τις ανάγκες των αρχιτεκτόνων και προσφέρουμε λύσεις που μετατρέπουν το όραμά σας σε πραγματικότητα.',

    // Private modal
    'priv.title': 'Ιδιώτες',
    'priv.h3': 'Μεταμορφώστε το Σπίτι σας',
    'priv.p1': 'Αναβαθμίστε την κατοικία σας με τα υψηλής ποιότητας συστήματα αλουμινίου της Χατζηανδρέου. Προσφέρουμε ολοκληρωμένες λύσεις για κουφώματα, πόρτες, παράθυρα και κατασκευές που συνδυάζουν αισθητική, ασφάλεια και ενεργειακή απόδοση.',
    'priv.h4': 'Τι προσφέρουμε:',
    'priv.list': [
      'Παράθυρα και μπαλκονόπορτες υψηλής θερμομόνωσης',
      'Θωρακισμένες πόρτες εισόδου',
      'Συστήματα σκίασης (ρολά, σίτες, περσίδες)',
      'Κουφώματα σε μεγάλη ποικιλία χρωμάτων και σχεδίων',
      'Δωρεάν επιτόπια επίσκεψη και προσφορά',
      'Επαγγελματική τοποθέτηση',
      'Εγγύηση προϊόντων και υπηρεσιών',
    ],
    'priv.p2': 'Με την εμπειρία και την εξειδίκευσή μας, σας εγγυόμαστε αποτελέσματα που θα ξεπεράσουν τις προσδοκίες σας. Το σπίτι σας αξίζει το καλύτερο.',

    // Company modal
    'comp.title': 'Εταιρεία',
    'comp.h3': 'Η Ιστορία μας',
    'comp.p1': 'Η Χατζηανδρέου είναι μια οικογενειακή επιχείρηση με πολυετή παράδοση στον τομέα των μεταλλικών κατασκευών και των συστημάτων αλουμινίου. Από το 1985, υπηρετούμε με συνέπεια και επαγγελματισμό τις ανάγκες πελατών σε όλη την Ελλάδα.',
    'comp.values': 'Οι Αξίες μας',
    'comp.v1': 'Ποιότητα',
    'comp.v1t': 'Χρησιμοποιούμε μόνο πιστοποιημένα υλικά από κορυφαίους κατασκευαστές',
    'comp.v2': 'Καινοτομία',
    'comp.v2t': 'Ακολουθούμε τις τελευταίες τεχνολογικές εξελίξεις του κλάδου',
    'comp.v3': 'Αξιοπιστία',
    'comp.v3t': 'Τηρούμε πάντα τις δεσμεύσεις μας προς τους πελάτες μας',
    'comp.v4': 'Εξυπηρέτηση',
    'comp.v4t': 'Προσφέρουμε ολοκληρωμένη τεχνική υποστήριξη σε όλα τα στάδια',
    'comp.vision': 'Το Όραμά μας',
    'comp.visionP': 'Να αποτελούμε την πρώτη επιλογή για αρχιτέκτονες, μηχανικούς και ιδιώτες που αναζητούν κορυφαία ποιότητα σε συστήματα αλουμινίου και μεταλλικές κατασκευές. Στοχεύουμε στη συνεχή βελτίωση των υπηρεσιών μας και στην ικανοποίηση των πελατών μας.',
    'comp.team': 'Η Ομάδα',
    'comp.teamP': 'Διαθέτουμε έμπειρο προσωπικό εξειδικευμένο σε όλους τους τομείς των μεταλλικών κατασκευών. Από το σχεδιασμό μέχρι την τοποθέτηση, η ομάδα μας εργάζεται με επαγγελματισμό και προσοχή στη λεπτομέρεια για να σας προσφέρει το καλύτερο δυνατό αποτέλεσμα.',
    'comp.stats.years': 'Χρόνια Εμπειρίας',
    'comp.stats.projects': 'Ολοκληρωμένα Έργα',
    'comp.stats.happy': 'Ικανοποιημένοι Πελάτες',

    // Contact modal
    'contact.title': 'Επικοινωνία',
    'contact.info': 'Στοιχεία Επικοινωνίας',
    'contact.phone': 'Τηλέφωνο',
    'contact.address': 'Διεύθυνση',
    'contact.hours': 'Ωράριο Λειτουργίας',
    'contact.hoursWeek': 'Δευτέρα - Παρασκευή: 08:00 - 17:00',
    'contact.hoursSat': 'Σάββατο: 09:00 - 14:00',
    'contact.hoursSun': 'Κυριακή: Κλειστά',
    'contact.sendMessage': 'Στείλτε μας Μήνυμα',
    'contact.namePh': 'Ονοματεπώνυμο',
    'contact.phonePh': 'Τηλέφωνο',
    'contact.messagePh': 'Το μήνυμά σας...',
    'contact.send': 'Αποστολή Μηνύματος',
    'contact.thanks': 'Ευχαριστούμε για το μήνυμά σας! Θα επικοινωνήσουμε μαζί σας σύντομα.',

    // Aluminum systems modal
    'alum.title': 'Συστήματα Αλουμινίου',
    'alum.intro': 'Ανακαλύψτε την πλήρη σειρά συστημάτων αλουμινίου μας. Κάθε κατηγορία περιλαμβάνει προϊόντα υψηλής ποιότητας με πιστοποιήσεις και εγγύηση.',
    'alum.cat.opening': 'Ανοιγόμενα Κουφώματα',
    'alum.cat.opening.desc': 'Κλασικά ανοιγόμενα συστήματα με εξαιρετική θερμομόνωση',
    'alum.cat.sliding': 'Συρόμενα Κουφώματα',
    'alum.cat.sliding.desc': 'Σύγχρονα συρόμενα συστήματα για μέγιστη εξοικονόμηση χώρου',
    'alum.cat.doors': 'Πόρτες Εισόδου',
    'alum.cat.doors.desc': 'Θωρακισμένες πόρτες εισόδου με σύγχρονο design',
    'alum.cat.shutters': 'Φυσούνες',
    'alum.cat.shutters.desc': 'Ρολά ασφαλείας και φυσούνες για κάθε ανάγκη',
    'alum.cat.shading': 'Συστήματα Σκίασης',
    'alum.cat.shading.desc': 'Pergolas, σκίαστρα και συστήματα εξωτερικής σκίασης',
    'alum.cat.curtain-wall': 'Υαλοπετάσματα',
    'alum.cat.curtain-wall.desc': 'Γυάλινες προσόψεις και υαλοπετάσματα για μοντέρνα κτίρια',

    // Product Detail
    'pdp.tab.description': 'Περιγραφή',
    'pdp.tab.description.short': 'Περιγραφή',
    'pdp.tab.technical': 'Τεχνικά Χαρακτηριστικά',
    'pdp.tab.technical.short': 'Τεχνικά',
    'pdp.tab.certifications': 'Πιστοποιήσεις',
    'pdp.tab.certifications.short': 'Πιστοποιήσεις',
    'pdp.products': 'Προϊόντα',
    'pdp.code': 'Κωδικός',
    'pdp.noDescription': 'Δεν υπάρχει περιγραφή.',
    'pdp.noTechnical': 'Δεν υπάρχουν τεχνικά χαρακτηριστικά.',
    'pdp.noCerts': 'Δεν έχουν αναρτηθεί πιστοποιήσεις για αυτό το προϊόν.',
    'pdp.cta.h3': 'Για περισσότερες πληροφορίες',
    'pdp.cta.p': 'επικοινωνήστε μαζί μας',

    // ESPA
    'espa.title': 'Ενίσχυση Ίδρυσης ΜμΕ – ΕΣΠΑ 2021-2027',
    'espa.p1': 'Η επιχείρηση χρηματοδοτήθηκε από τη Δράση "Ενίσχυση της Ίδρυσης και Λειτουργίας Νέων Μικρομεσαίων Επιχειρήσεων" του Προγράμματος Ανταγωνιστικότητα (ΕΣΠΑ 2021-2027).',
    'espa.p2': 'Η Δράση στοχεύει στην ενίσχυση των επενδυτικών σχεδίων υπό ίδρυση και νεοσύστατων επιχειρήσεων ΜμΕ, οι οποίες θα επενδύσουν ίδιους πόρους στη δραστηριότητα που προτίθενται να ασκήσουν και θα δημιουργήσουν νέες θέσεις απασχόλησης.',
    'espa.footer': 'Με τη συγχρηματοδότηση της Ευρωπαϊκής Ένωσης',
  },

  en: {
    'nav.architects': 'ARCHITECTS',
    'nav.private': 'PRIVATE',
    'nav.aluminum': 'ALUMINUM SYSTEMS',
    'nav.company': 'COMPANY',
    'nav.contact': 'CONTACT',
    'home.title': 'CHATZIANDREOU',
    'home.subtitle': 'METAL CONSTRUCTIONS - ALUMINUM SYSTEMS',
    'home.skip': 'Skip to main content',

    'common.close': 'Close',
    'common.back': 'Back',
    'common.viewMore': 'View More',
    'common.home': 'Home',
    'common.download': 'Download',
    'common.loading': 'Loading...',
    'common.partnerLogin': 'Partner Login',

    'arch.title': 'Architects',
    'arch.h3': 'Solutions for Professional Architects',
    'arch.p1': 'Chatziandreou works closely with architects and designers to bring the most demanding architectural plans to life. We offer specialized aluminum solutions that combine aesthetics, functionality and energy efficiency.',
    'arch.h4': 'Services we offer:',
    'arch.list': [
      'Technical support and consulting at every stage of the project',
      'Custom solutions for special architectural requirements',
      'Custom aluminum system design',
      '3D renderings and studies',
      'Certified products with high specifications',
      'On-time delivery and on-budget execution',
    ],
    'arch.p2': 'With decades of industry experience, we understand architects\' needs and offer solutions that turn your vision into reality.',

    'priv.title': 'Private Clients',
    'priv.h3': 'Transform Your Home',
    'priv.p1': 'Upgrade your home with Chatziandreou\'s high-quality aluminum systems. We offer complete solutions for frames, doors, windows and structures that combine aesthetics, safety and energy efficiency.',
    'priv.h4': 'What we offer:',
    'priv.list': [
      'High thermal insulation windows and balcony doors',
      'Armored entrance doors',
      'Shading systems (shutters, screens, blinds)',
      'Frames in a wide variety of colors and designs',
      'Free on-site visit and quote',
      'Professional installation',
      'Product and service warranty',
    ],
    'priv.p2': 'With our experience and expertise, we guarantee results that exceed your expectations. Your home deserves the best.',

    'comp.title': 'Company',
    'comp.h3': 'Our Story',
    'comp.p1': 'Chatziandreou is a family business with a long tradition in metal constructions and aluminum systems. Since 1985, we have consistently and professionally served customers throughout Greece.',
    'comp.values': 'Our Values',
    'comp.v1': 'Quality',
    'comp.v1t': 'We use only certified materials from top manufacturers',
    'comp.v2': 'Innovation',
    'comp.v2t': 'We follow the latest technological developments in the industry',
    'comp.v3': 'Reliability',
    'comp.v3t': 'We always keep our commitments to our customers',
    'comp.v4': 'Service',
    'comp.v4t': 'We provide comprehensive technical support at all stages',
    'comp.vision': 'Our Vision',
    'comp.visionP': 'To be the first choice for architects, engineers and individuals seeking top quality in aluminum systems and metal constructions. We aim for continuous improvement of our services and customer satisfaction.',
    'comp.team': 'Our Team',
    'comp.teamP': 'We have experienced staff specialized in all areas of metal construction. From design to installation, our team works with professionalism and attention to detail to deliver the best possible result.',
    'comp.stats.years': 'Years of Experience',
    'comp.stats.projects': 'Completed Projects',
    'comp.stats.happy': 'Happy Customers',

    'contact.title': 'Contact',
    'contact.info': 'Contact Details',
    'contact.phone': 'Phone',
    'contact.address': 'Address',
    'contact.hours': 'Business Hours',
    'contact.hoursWeek': 'Monday - Friday: 08:00 - 17:00',
    'contact.hoursSat': 'Saturday: 09:00 - 14:00',
    'contact.hoursSun': 'Sunday: Closed',
    'contact.sendMessage': 'Send us a Message',
    'contact.namePh': 'Full Name',
    'contact.phonePh': 'Phone',
    'contact.messagePh': 'Your message...',
    'contact.send': 'Send Message',
    'contact.thanks': 'Thank you for your message! We will contact you soon.',

    'alum.title': 'Aluminum Systems',
    'alum.intro': 'Discover our complete range of aluminum systems. Each category includes high-quality certified and warrantied products.',
    'alum.cat.opening': 'Hinged Frames',
    'alum.cat.opening.desc': 'Classic hinged systems with excellent thermal insulation',
    'alum.cat.sliding': 'Sliding Frames',
    'alum.cat.sliding.desc': 'Modern sliding systems for maximum space efficiency',
    'alum.cat.doors': 'Entrance Doors',
    'alum.cat.doors.desc': 'Armored entrance doors with modern design',
    'alum.cat.shutters': 'Shutters',
    'alum.cat.shutters.desc': 'Security shutters and blinds for every need',
    'alum.cat.shading': 'Shading Systems',
    'alum.cat.shading.desc': 'Pergolas, awnings and outdoor shading systems',
    'alum.cat.curtain-wall': 'Curtain Walls',
    'alum.cat.curtain-wall.desc': 'Glass facades and curtain walls for modern buildings',

    'pdp.tab.description': 'Description',
    'pdp.tab.description.short': 'Description',
    'pdp.tab.technical': 'Technical Specifications',
    'pdp.tab.technical.short': 'Technical',
    'pdp.tab.certifications': 'Certifications',
    'pdp.tab.certifications.short': 'Certifications',
    'pdp.products': 'Products',
    'pdp.code': 'Code',
    'pdp.noDescription': 'No description available.',
    'pdp.noTechnical': 'No technical specifications available.',
    'pdp.noCerts': 'No certifications have been posted for this product.',
    'pdp.cta.h3': 'For more information',
    'pdp.cta.p': 'contact us',

    'espa.title': 'SME Establishment Funding – NSRF 2021-2027',
    'espa.p1': 'This business was funded by the Action "Support for the Establishment and Operation of New Small and Medium-sized Enterprises" of the Competitiveness Program (NSRF 2021-2027).',
    'espa.p2': 'The Action aims to support investment plans of newly established and start-up SMEs that will invest their own resources in the activity they intend to pursue and create new jobs.',
    'espa.footer': 'Co-financed by the European Union',
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('qals_lang') || 'el';
    } catch {
      return 'el';
    }
  });

  useEffect(() => {
    try { localStorage.setItem('qals_lang', lang); } catch { /* ignore */ }
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, fallback = '') => {
    const val = dictionary[lang]?.[key];
    if (val !== undefined) return val;
    return dictionary.el?.[key] ?? fallback ?? key;
  };

  const toggleLang = () => setLang(l => (l === 'el' ? 'en' : 'el'));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
};

// Helper: pick the appropriate value based on current language
export const pickLang = (obj, key, lang) => {
  if (!obj) return '';
  if (lang === 'en') {
    return obj[`${key}_en`] || obj[key] || '';
  }
  return obj[key] || '';
};
